import Vue from 'vue'

Vue.mixin({
    methods: {
        formatNumber (value) {
          value = value.toString()
          return value ? value.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : ''
        },
        formatMoney (price = 0) {
            const formatter = new Intl.NumberFormat('nl-NL', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 0
            })
            return formatter.format(price)
          },
          objectToFormData (obj) {
            var formData = new FormData()
            Object.entries(obj).forEach(entry => {
              formData.append(entry[0], entry[1])
            })
            return formData
          },
          capitalize (s) {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
          },
          isBetaCore (user) {
            if (user && user.companyId && user.companyId === '5f889efba44a97e52ad8a26d') {
              return true
            }
          },
          CSVToArray (text) {
            var rows = text.split('\n')

            return rows.map(function (row) {
              return row.split(',')
            })
        }
    }
})
